<template>
  <div class="distributor-box details_box_styles">
    <!--返回按钮-->
    <div class="go-back" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <!--步骤条-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <h2 class="title_center" v-if="detailsData.stockUpCode">{{ detailsData.stockUpCode + (detailsData.ymsStatus === 4 ? $t('key1005936') : '') }}</h2>
        <div class="steps_box" style="width: 70%" v-if="detailsData.ymsStatus !==4">
          <Steps :current="currentStatus">
            <Step
              v-for="(ele, ids) in stepsList"
              :key="ids"
              :title="ele.title"
              :icon="ele.icon"
              :content="ele.time">
            </Step>
          </Steps>
        </div>
      </Card>
    </div>
    <!--订单信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004432') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="24" class="basic_item">
            <span class="basic_title">{{ $t('key1005937') + stockingWarehouseName }}</span>
          </Col>
        </Row>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="6" class="basic_item" v-for="ele in productInfoList">
            <span class="basic_title">{{ ele.title + '：' }}</span>
            <span class="basic_txt">{{ detailsData[ele.paramsKey] }}</span>
          </Col>
        </Row>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="6" class="basic_item" v-for="ele in amountInfoList">
            <span class="basic_title">{{ ele.title + '：' }}</span>
            <span class="basic_txt">{{ detailsData[ele.paramsKey] }}</span>
          </Col>
          <Col :span="6" class="basic_item" v-if="originalDetailsData.cancelledAmount && !(!originalDetailsData.payTime && originalDetailsData.status === 8)">
            <span class="basic_title">{{ $t('key1005938') }}</span>
            <span class="basic_txt">{{ detailsData.cancelledAmount }}</span>
          </Col>
          <Col :span="6" class="basic_item" v-if="originalDetailsData.newRefundAmount">
            <span class="basic_title">{{ $t('key1000234') }}</span>
            <span class="basic_txt">{{ detailsData.refundAmount }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--订单商品-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004421') }}</h2>
        </template>
        <Table
          ref="tableDom"
          highlight-row
          border
          max-height="400"
          :loading="tableLoading"
          :columns="tableColumns"
          :span-method="handleSpan"
          :data="tableData">
        </Table>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel} from "@/utils/common";

export default {
  name: 'distributorStockListDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      detailsData: {},
      currentStatus: 0,
      stepsList: [],
      tableData: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 330,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let skuImg = '';
            let spuImg = '';
            if (params.row._productInfo) {
              skuImg = params.row._productInfo.primaryImage;
              spuImg = params.row._productInfo._spuInfo.primaryImage;
            }
            let primaryImage = skuImg || spuImg || v.failPlaceholder;
            let list = [
              v.tableImg(h, params, '', primaryImage),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 200,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let list = [];
            let ymsSku = params.row.ymsSku;
            let productGoodsSpecifications = params.row._productInfo.productGoodsSpecificationList || [];
            if (productGoodsSpecifications.length > 0) {
              list = productGoodsSpecifications.map((item) => {
                return item.value;
              });
            }
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, list.join(' • '))
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005923'),
          key: 'originalProductGoodsCost',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let originalProductGoodsCost = params.row.originalProductGoodsCost || 0;
            let currency = params.row.currency || v.currencyState;
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, currency),
              h('div', v.formatCurrency(originalProductGoodsCost)),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005924'),
          key: 'productGoodsCost',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let productGoodsCost = params.row.productGoodsCost || 0;
            let currency = params.row.currency || v.currencyState;
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, currency),
              h('div', v.formatCurrency(productGoodsCost)),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005925'),
          key: 'quantity',
          minWidth: 120,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005926'),
          key: 'quantityToWarehouse',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let quantity = params.row.quantity;
            let actualSortingNumber = params.row.actualSortingNumber;
            let talg = quantity && actualSortingNumber && quantity !== actualSortingNumber;
            return h('span', {class: talg ? 'crimsonRedColor' : ''}, actualSortingNumber || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003963'),
          key: 'numberOfListings',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let shelveQuantity = params.row.shelveQuantity;
            let actualSortingNumber = params.row.actualSortingNumber;
            let talg = shelveQuantity && actualSortingNumber && shelveQuantity !== actualSortingNumber;
            return h('span', {class: talg ? 'crimsonRedColor' : ''}, shelveQuantity || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004318'),
          key: 'refundQuantity',
          minWidth: 120,
          align: 'left',
          renderHeader(h) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004318')),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 300,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005927')
                },
                class: 'ml5',
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 18
                  },
                  style: {
                    cursor: 'pointer',
                    color: '#AAAAAA'
                  }
                })
              ])
            ]);
          },
          render(h, params) {
            if (v.originalDetailsData.newRefundAmount) {
              let refundQuantity = params.row.refundQuantity || '-';
              return h('span', {class: refundQuantity > 0 ? 'crimsonRedColor' : ''}, refundQuantity);
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317'),
          key: 'cancelQuantity',
          minWidth: 120,
          align: 'left',
          renderHeader(h) {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317')),
              h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 250,
                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005928')
                },
                class: 'ml5',
              }, [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 18
                  },
                  style: {
                    cursor: 'pointer',
                    color: '#AAAAAA'
                  }
                })
              ])
            ]);
          },
          render(h, params) {
            if (Number(v.originalDetailsData.cancelledAmount)) {
              let cancelQuantity = params.row.cancelQuantity || '-';
              return h('span', {class: cancelQuantity > 0 ? 'crimsonRedColor' : '', cancelQuantity}, cancelQuantity);
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          align: 'left',
          minWidth: 220,
          render: (h, params) => {
            let abnormalStatus = params.row.abnormalStatus;  // 货品异常状态 1.正常 2.缺货 3.部分缺货
            let goodsStatus = params.row.goodsStatus; // 1.正常 2.停售
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let outOfStockQuantity = params.row.outOfStockQuantity || '-';
            if (goodsStatus === 2) {
              return h('div', {class: 'crimsonRedColor'}, [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084')),
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360') + outOfStockQuantity)
              ]);
            } else {
              if (abnormalStatus === 2) {
                return h('div', {class: 'crimsonRedColor text-align-left'}, [
                  h('p', {class: 'mt3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364')),
                  estimateArrivalOfGoodsTime ? h('p', {class: 'crimsonRedColor mt3 flex'}, [
                    h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                    h('span', estimateArrivalOfGoodsTime)
                  ]) : '',
                ]);
              } else {
                return h('p', '-');
              }
            }
          }
        },
      ],
      productInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'), paramsKey: 'orderTotalQuantity'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005929'), paramsKey: 'totalWeight'},
      ],
      amountInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005930'), paramsKey: 'originalProductGoodsTotalPrice'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'), paramsKey: 'adjustPrice'}
      ],
      stockingWarehouseName: '',
      originalDetailsData: {}
    };
  },
  created() {
    let ymsStockUpInfoId = this.$route.query.ymsStockUpInfoId;
    this.stockingWarehouseName = this.$route.query.stockingWarehouseName;
    this.getSpareNoteDetails(ymsStockUpInfoId);
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/distributorStockList');
    },
    // 获取备货单详情
    getSpareNoteDetails(ymsStockUpInfoId) {
      let ymsProductGoodsIds = [];
      this.axios.get(api.get_ymsDistributorStockUpInfo + `${ymsStockUpInfoId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let ymsSubPackageInfoList = data.ymsSubPackageInfoList || [];
            this.originalDetailsData = JSON.parse(JSON.stringify(data));
            let ymsStatus = data.ymsStatus; // 订单状态 1.待付款、2.备货中、 21.收货中 3.已完结、4.已取消
            // 步骤条
            this.stepsList = [
              {currentStatus: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
              {currentStatus: 1, icon: 'md-contacts', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005931'), time: data.payTime},
              {currentStatus: 2, icon: 'ios-cart', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932'), time: data.shipedTime},
              {currentStatus: 3, icon: 'md-cube', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005933'), time: data.allottedTime},
            ];
            this.stepsList.map((item) => {
              if (item.time) {
                this.currentStatus = item.currentStatus;
                item.time = this.$uDate.dealTime(item.time, 'fulltime');
              }
            });
            let titleList = [];
            switch (ymsStatus) {
              case 1:
                titleList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005934'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005935')];
                this.currentStatus = 1;
                break;
              case 2:
                titleList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005931'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005935')];
                this.currentStatus = 2;
                break;
              case 21:
                titleList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005931'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002022'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005935')]; // 收货中---最后一个子单入库流转为收货中
                this.currentStatus = 2;
                break;
              case 3:
                titleList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005931'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005933')]; // 已收货-展示的时间---按最后一个子单分拣结束时间
                this.currentStatus = 3;
                break;
            }
            this.stepsList.map((item, index) => {
              if (this.currentStatus === 2 && this.currentStatus === item.currentStatus) {
                item.time = '';
              }
              item.title = titleList[index];
            });

            this.originalDetailsData['newRefundAmount'] = data.refundAmount;
            // 处理订单信息
            let keyList = [
              {currencyKey: 'originalProductGoodsTotalPriceCurrency', fieldKey: 'originalProductGoodsTotalPrice'},
              {currencyKey: 'distributorPayableAmountCurrency', fieldKey: 'adjustPrice'},
              {currencyKey: 'distributorPaidAmountCurrency', fieldKey: 'distributorPaidAmount'},
              {currencyKey: 'refundAmountCurrency', fieldKey: 'refundAmount'},
              {currencyKey: 'cancelledCurrency', fieldKey: 'cancelledAmount'}
            ];
            keyList.map((item) => {
              let currency = data[item.currencyKey] || this.currencyState;
              data[item.fieldKey] = currency + ' ' + amountHandel(data[item.fieldKey]);
            });

            // 获取所有子单的货品数据
            let ymsSubPackageGoodsData = [];
            if (ymsSubPackageInfoList.length > 0) {
              ymsSubPackageGoodsData = ymsSubPackageInfoList.flatMap(item => {
                return item.ymsSubPackageGoodsList.map(goodsItem => {
                  goodsItem.needPurchase = item.needPurchase;
                  return goodsItem;
                });
              });
            }

            // 处理货品信息
            let ymsStockUpGoods = data.ymsStockUpGoods || [];
            if (ymsStockUpGoods.length > 0) {
              ymsStockUpGoods.map((item) => {
                ymsProductGoodsIds.push(item.ymsProductGoodsId);
              });
            }
            if (ymsProductGoodsIds.length > 0) {
              this.getProductInfoByIds(ymsProductGoodsIds, ymsStockUpGoods).then((newData) => {
                if (newData && newData.length > 0) {
                  function handleNum(newList, key) {
                    return newList.reduce((total, current) => {
                      return total + (current[key] || 0);
                    }, 0);
                  }
                  newData.map((item) => {
                    item.ymsSpu = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.ymsSpu : null : null;
                    ymsSubPackageGoodsData.map((ele) => {
                      if (item.ymsSku === ele.ymsSku) {
                        let newList = ymsSubPackageGoodsData.filter((talg) => {
                          return talg.ymsSku === item.ymsSku;
                        });
                        // 是否需要采购:0 否   1 是
                        let purchaseTotal = 0;
                        let notPurchasingTotal = 0;
                        let purchaseList = newList.filter((item) => {
                          return item.needPurchase === 1;
                        });
                        // 采购
                        if (purchaseList.length > 0) {
                          purchaseTotal = handleNum(purchaseList, 'actualSortingNumber');
                        }
                        // 不采购
                        let notPurchasingList = newList.filter((item) => {
                          return item.needPurchase === 0;
                        });
                        if (notPurchasingList.length > 0) {
                          notPurchasingTotal = handleNum(notPurchasingList, 'quantity');
                        }
                        // 到仓数量
                        let actualSortingTotal = purchaseTotal + notPurchasingTotal;
                        // 上架数量
                        let shelveTotal = handleNum(newList, 'shelveQuantity');
                        // 退款数量
                        let refundTotal = handleNum(newList, 'refundQuantity');
                        // 取消数量
                        let cancelTotal = handleNum(newList, 'cancelQuantity');

                        item.actualSortingNumber = actualSortingTotal; // 到仓数量
                        item.shelveQuantity = shelveTotal;
                        item.cancelQuantity = cancelTotal;
                        item.refundQuantity = refundTotal;
                        item.outOfStockQuantity = ele.outOfStockQuantity;
                      }
                    });
                  });
                  this.handleTableData(newData);
                }
              });
            }
            this.detailsData = data;
          }
        }
      });
    },
    // 处理列表数据,按照SPU维度合并行数据
    handleTableData(data) {
      let v = this;
      let newList = [];
      if (data.length > 0) {
        let newData = v.handerGrouping(data, function (item) {
          return [item.ymsSpu];
        }, 'ymsSpu', 'ymsSkuList');
        if (newData.length > 0) {
          newData.map((ele) => {
            let length = ele.ymsSkuList.length;
            ele.ymsSkuList.map((talg, index) => {
              talg['length'] = length;
              talg['currentTalg'] = (length > 1 && index === 0);
              newList.push(talg);
            });
          });
        }
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
          });
          v.tableData = newList;
          v.updateTableDom('tableDom');
        }
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      let handleKeyList = ['skuInfo', 'originalProductGoodsCost', 'productGoodsCost', 'quantity',
        'cancelQuantity', 'quantityToWarehouse', 'numberOfListings', 'refundQuantity', 'abnormalStatus'];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!handleKeyList.includes(item.key)) {
            columnList.push(index);
          }
        });
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>